let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
    {
        label: '订单编号',
        props: 'orderNo',
        minWidth: 200,
        tooltip: true,
    },
    {
        label: '微信订单号',
        props: 'payWalletList',
        minWidth: 200,
        tooltip: true,
    },
    {
        label: '运营商',
        props: 'corpName',
        minWidth: 160,
        tooltip: true,
    },
    {
        label: '站点名称',
        props: 'stationName',
        minWidth: 200,
        tooltip: true,
    },
    {
        label: '用户手机',
        props: 'custPhone',
        minWidth: 140,
    },
    {
        label: '桩号',
        props: 'pileCode',
        minWidth: 200,
    },
    {
        label: '充电日期',
        props: 'chargeDay',
        minWidth: 200,
    },
    {
        label: '平台实际费用',
        props: 'tActFee',
        minWidth: 160,
    },
    {
        label: '财付通金额',
        props: 'inExpAmount',
        minWidth: 200,
    },
    {
        label: '是否匹配',
        props: 'orderFlag',
        minWidth: 120,
        formatter: function formatter(row, column, cellValue, index) {
            return row.orderFlag == 'Y' ? '是' : '否'
        }
    },
];

pageConfig.rules = {
    taskName: [{
        required: true,
        message: "请输入任务名称",
        trigger: "blur"
    }],
    orderChargeMonth: [{
        required: true,
        message: "请选择月份",
        trigger: ["blur", "change"]
    }],
    file: [{
        required: true,
        message: "请上传文件",
        trigger: "change"
    }],
}

// 面包屑
pageConfig.listBreadCrumb = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '财务管理'
    },
    {
        type: 'title',
        name: '对账管理'
    }
];

// 列表-表格属性
pageConfig.tableConfig = {
    showSelection: false,
    showIndex: true,
};

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}

export default pageConfig;